'use client';

import { AuthShell } from "@/components/sections/auth/AuthShell";
import { RegisterForm } from "@/components/sections/auth/RegisterForm";
import { RegisterFormCrieOferta } from "@/components/sections/auth/RegisterFormCrieOferta";
import NoAuthGuard from "@/components/guards/NoAuthGuard";
import { Suspense } from "react";
import { useSearchParams } from "next/navigation";

function CadastroContent() {
  const searchParams = useSearchParams();
  const ref = searchParams.get("ref");
  const isCrieOferta = !!ref;

  return (
    <NoAuthGuard>
      <AuthShell
        title={isCrieOferta ? "Complete seu cadastro" : "Crie sua conta"}
        subtitle={isCrieOferta 
          ? "Finalize seu cadastro vinculado ao Crie Oferta" 
          : "Cadastre-se para acessar recursos exclusivos"
        }
      >
        {isCrieOferta ? <RegisterFormCrieOferta /> : <RegisterForm />}
      </AuthShell>
    </NoAuthGuard>
  );
}

export default function CadastroPage() {
  return (
    <Suspense fallback={
      <div className="flex min-h-screen items-center justify-center bg-[#0d0d12]">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-brand-primary border-t-transparent" />
      </div>
    }>
      <CadastroContent />
    </Suspense>
  );
}
